// deps
import React, { memo, FormEvent, useState, useEffect } from "react";

// dls
import { RadioGroup } from "@swiggy-private/dls-web-core/dist/components/RadioGroup";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

//styles
import { ContentHeader } from "./styles";

// helpers
import { SORT_ID_FILTERS, TEXTS } from "../constants";
import { transformSortObject, getDefaultSortValue } from "../helpers";

import { ISortContent } from "../types";

function SortContent({ sortList, updateFilterList, selectedFilters }: ISortContent) {
    const sortValue = getDefaultSortValue(sortList);
    const [value, setValue] = useState(selectedFilters[0] ?? sortValue);

    useEffect(() => {
        setValue(selectedFilters[0] ?? sortValue);
    }, [selectedFilters, sortValue]);

    return (
        <>
            <ContentHeader>
                <Text variant="V2.body2.neutral.regular" color="text_Med_Emphasis">
                    {TEXTS.SORT_BY}
                </Text>
            </ContentHeader>
            <RadioGroup
                name="Sort"
                value={value}
                orientation="ltr"
                items={transformSortObject(sortList)}
                onChange={(e: FormEvent) => {
                    const target = e.target as HTMLInputElement;
                    setValue(target.value);
                    updateFilterList([target.value], SORT_ID_FILTERS);
                }}
            />
        </>
    );
}

export default memo(SortContent);
